<script setup>
import { useTemplateRef, computed } from 'vue';
import { useCampaignFilterContext } from './campaignProvider.js';
import { useSnakeCase } from 'dashboard/composables/useTransformKeys';

import Button from 'next/button/Button.vue';
import ConditionRow from './ConditionRow.vue';

const { filterTypes } = useCampaignFilterContext();

const filters = defineModel({
  type: Array,
  default: [],
});

const DEFAULT_FILTER = {
  attributeKey: 'phone_number',
  filterOperator: 'is_present',
  values: [],
  queryOperator: 'and',
  attributeModel: 'standard',
};

const resetFilter = () => {
  filters.value = [{ ...DEFAULT_FILTER }];
};

const removeFilter = index => {
  if (filters.value.length === 1) {
    resetFilter();
  } else {
    filters.value.splice(index, 1);
  }
};

const addFilter = () => {
  filters.value.push({ ...DEFAULT_FILTER });
};

const conditionsRef = useTemplateRef('conditionsRef');

const isConditionsValid = () => {
  return conditionsRef.value?.every(condition => condition.validate()) ?? true;
};

const previewPayload = computed(() => {
  return useSnakeCase(JSON.parse(JSON.stringify(filters.value)));
});

defineExpose({ previewPayload, isConditionsValid });
</script>

<template>
  <div class="grid gap-4">
    <ul class="grid gap-3 list-none">
      <template
        v-for="(filter, index) in filters"
        :key="`campaign-filter-${index}`"
      >
        <ConditionRow
          v-if="index === 0"
          ref="conditionsRef"
          v-model:attribute-key="filter.attributeKey"
          v-model:filter-operator="filter.filterOperator"
          v-model:values="filter.values"
          :filter-types="filterTypes"
          :show-query-operator="false"
          @remove="removeFilter(index)"
        />
        <ConditionRow
          v-else
          ref="conditionsRef"
          v-model:attribute-key="filter.attributeKey"
          v-model:filter-operator="filter.filterOperator"
          v-model:query-operator="filters[index - 1].queryOperator"
          v-model:values="filter.values"
          show-query-operator
          :filter-types="filterTypes"
          @remove="removeFilter(index)"
        />
      </template>
    </ul>
    <div class="flex gap-2">
      <Button sm ghost blue @click="addFilter">
        {{ $t('FILTER.ADD_NEW_FILTER') || 'Add filter' }}
      </Button>
      <Button sm faded slate @click="resetFilter">
        {{ $t('FILTER.CLEAR_BUTTON_LABEL') || 'Clear' }}
      </Button>
    </div>
  </div>
</template>
